import type { NumberOfUnseenAlerts } from '../types';

export interface UnseenAlerts {
  readonly amount: NumberOfUnseenAlerts;
  readonly hasAlerts: boolean;
}

export const unseenAlerts = {
  create: (amount: NumberOfUnseenAlerts): UnseenAlerts =>
    Object.freeze({
      amount,
      hasAlerts: amount > 0,
    }),
};
